import { useIsAnomaliesTrendVisible } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Alert, Box, Stack } from '@mui/material';

export const QuantifySaveActionAlert = () => {
  const isAnomaliesTrendVisible = useIsAnomaliesTrendVisible();

  const shouldShowTopDataPoints = useQuantifyStore(
    ({ metadata }) => metadata.shouldShowTopDataPoints,
  );

  if (isAnomaliesTrendVisible && !shouldShowTopDataPoints) {
    return (
      <Alert severity="warning">
        <Stack spacing={1}>
          <Box>
            You have manually selected values in the table. Please note that we
            will track your selections, which may not be considered anomalous in
            the future.
          </Box>
          <Box>
            To show Top Anomalies, please reset the table to its default Top
            values.
          </Box>
        </Stack>
      </Alert>
    );
  }

  return null;
};
